module.exports = __webpack_public_path__ + "static/media/BodyOfWater.29afbf0f.svg";